import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  templatesViewColumns,
  mapTemplatesViewQuery,
} from "./TemplatesView.default";
import { getTemplates, getCategories } from "../repository/data.repository";
import { NotificationType } from "../repository/data.default";
import { InputObject } from "../controls/default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createSearchRequest } from "../hooks/useSearchRequest";
import { createGridRequest } from "../hooks/useGridRequest";

export interface TemplatesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

const categoriesRequest = createSearchRequest(getCategories, "name");

const notificationOptions = async (): Promise<InputObject[]> =>
  Object.values(NotificationType).map((type) => ({ display: type, value: type }));

function TemplatesView(props: TemplatesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={templatesViewColumns}
      mapQuery={mapTemplatesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getTemplates, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              { type: "textbox", name: "subject", label: "Subject" },
              { type: "textbox", name: "body", label: "Body" },
              { type: "textbox", name: "version", label: "Version" },
              {
                type: "combobox",
                name: "notificationType",
                label: "Notification Type",
                request: notificationOptions,
              },
              {
                type: "combobox",
                name: "categoryName",
                label: "Category",
                request: categoriesRequest,
              },
            ],
          },
        ],
      }}
      actions={(record) => [
        {
          key: "history",
          label: "History",
          disabled: !permissions.can("Templates", "view"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Templates", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("Templates", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default TemplatesView;
